<template>
  <div class="page-wrap">
  <img class="page-bg" :src="require('@/assets/images/login_background_image.webp')" alt="background image">   
    <div class="top-container">    
      <img id="logo" :src="require('@/assets/images/logo.png')" alt="Logo">
      <div class="top-title">Advanced AI</div>
    </div>
    <div class="page-content">
      <div class="divider"></div>
      <div class="wrapper-full-page">
        <div class="login-page" data-color="" :data-image="require('@/assets/images/login_background_image.webp')">
          <div class="content fade-in-div">
            <ModalBox :visible="showModal" :infoTitle="infoTitle"  :infoMessage="infoMessage" @close="showModal = false">
            </ModalBox>
            <div class="login_card" data-background="color" data-color="blue" v-if="showLogin">
              <div class="card-header">
                <div class="custom-divider"></div>
                <h4 class="card-title">Renox AI Portal</h4>
              </div>
              <div class="card-content">
                <form @submit.prevent="login">
                  <div class="form-group">
                    <input v-model="email" type="text" placeholder="Email" class="input-text underline-style" autocomplete="email" required>
                  </div>
                  <div class="form-group">
  <div class="password-input-wrapper">
    
    <input
      v-model="password"
      :type="showPassword ? 'text' : 'password'"
      placeholder="Password"
      class="input-text underline-style"
      autocomplete="current-password"
      required
    >
    <button
      v-if="password.length > 0"
      @click="togglePasswordVisibility"
      type="button"
      class="password-toggle-btn"
    >
      {{ showPassword ? 'Hide' : 'Show' }}
    </button>
  </div>
</div>

                  <button type="submit" class="login-button">Login</button>
                </form>
      
                <div class="forgot">
                  <div class="custom-divider"></div>
                  <a ref="forget" @mouseover="handleHover()" @click="showResetSendingEmail=true; showLogin=false">
                    <p>Forgot your password?</p>
                  </a>
                </div>
                <div class="forgot">
                  <br>
                  <a ref="forget" @mouseover="handleHover()" @click="showRegister=true; showLogin=false">
                  <p>No account? Register here</p>
                  </a>
                </div>
              </div>
            </div>
            <div class="card login_card" data-background="color" data-color="blue" v-if="showRegister">
              <button @click="showLogin=true; showRegister=false" type="button" class="btn btn-fill btn-wd btn-custom-back">Back to Login</button>
              <div class="card-header">
                <h5 class="card-title">Create Account</h5>
              </div>
              <div class="card-content">
                <form @submit.prevent="registerUser">
                  <div class="form-group">    
                    <input v-model="first_name" type="text" placeholder="First Name" class="underline-style" autocomplete="first_name" required>
                    <input v-model="last_name" type="text" placeholder="Last Name" class="underline-style" autocomplete="last_name" required>
                    <input v-model="email" type="text" placeholder="Email" class="underline-style" autocomplete="email" required>
                    <input v-model="password" type="password" placeholder="Password" class="underline-style" autocomplete="new-password" required>
                  </div>
                  <div class="info-disclaimer">
                <p>ATTENTION: Only accounts created with Renox corporative emails are whitelisted automatically. Any other account will need to be manually reviewed and approved</p>
              </div>
                  <div class="card-footer text-center">                   
                    <button type="submit" class="btn btn-fill btn-wd">Create  </button>
                  </div>
                </form>
              </div>
            </div>
       
            <div class="card login_card" data-background="color" data-color="blue" v-if="showResetSendingEmail">
              <button @click="showLogin=true;showResetSendingEmail=false" type="button" class="btn btn-fill btn-wd btn-custom-back">Back to Login</button>
              <div class="card-header">
                <h5 class="card-title">Initiate account recovery process</h5>
              </div>
              <div class="custom-divider"></div>
              <div class="card-content">
                <form @submit.prevent="sendEmail">
                  <div class="form-group">
                    <label>Enter the email address associated with the account</label>
                    <div class="custom-divider"></div>
                    <input v-model="email" type="text" placeholder="Email" class="underline-style" autocomplete="email" required>
                  </div>
                  
                  <div class="card-footer text-center">
                    <LoadingSpinner v-if="isLoading" />
      
                    <button v-if="!isLoading" type="submit" class="btn btn-fill btn-wd">Request</button>
                  </div>
                </form>
              </div>
            </div>
    
        <div class="card login_card" data-background="color" data-color="blue" v-if="showResetRecoveryCode">
              <button @click="showLogin=true; showResetRecoveryCode=false" type="button" class="btn-wd btn-custom-back">Back to Login</button>
              <div class="card-header">
                <h6 class="card-title custom-side-margins">An email with a recovery code has been sent to the entered email address. Please check your email inbox. Note: Make sure to check spams section, if you can not see it inside the primary inbox folder.</h6>
              </div>
              <div class="custom-divider"></div>
              <div class="card-content">
                <form @submit.prevent="recoverAccount">
                  <div class="form-group">
                    <label>Enter the recovery code from the email you received</label>
                    <div class="custom-divider"></div>
                    <div class="otp-input-wrapper">
                    <input v-model="recoveryCode" type="text" placeholder="Recovery Code" class="underline-style" autocomplete="code" required>
                  </div></div>
                  <div class="custom-divider"></div>
                  <div class="form-group">
                    <label>Set a new password for the account</label>
                    <div class="custom-divider"></div>
                    <div class="password-input-wrapper">
                    <input v-model="newPassword" :type="showPassword ? 'text' : 'password'" placeholder="New Password" class="underline-style" autocomplete="newPassword" required>
                    <button
      v-if="newPassword.length > 0"
      @click="togglePasswordVisibility"
      type="button"
      class="password-toggle-btn"
    >
      {{ showPassword ? 'Hide' : 'Show' }}
    </button>
                  </div>                  </div>
                  <div class="card-footer text-center">
                    <button type="submit" class="btn btn-fill btn-wd">Continue</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-semi-transparent">
          <p>Copyright &copy; {{year}} Renox Technology Pty Ltd &nbsp;&nbsp;</p>
          <a href="https://www.redx.com.au/terms-of-supply/"><p>General Terms</p></a>        
          <p>&nbsp;&nbsp;|&nbsp;&nbsp;</p>   
          <a href="https://www.redx.com.au/privacy-policy/"><p>Privacy Policy</p></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setUserInfo, getDevModeState } from '@/services/cookieService';
import { apiRequest } from '@/services/apiService';
import ModalBox from '@/components/cards/ModalBox.vue';
import LoadingSpinner from '../cards/LoadingSpinner.vue';
import { eventBus } from '@/services/eventBus';

export default {
  name: 'LoginPage',
  components: {
    ModalBox,
    LoadingSpinner
  },
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      first_name: '',
      last_name: '',
      showLogin: true,
      showRegister: false,
      showResetSendingEmail: false,
      showResetRecoveryCode: false,
      showModal: false,
      infoTitle: '',
      infoMessage: '',
      recoveryCode: '',
      newPassword: '',
      isLoading: false,
      nonDataSlug: "api",
    };
  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },

  methods: {
    handleEnvironmentChange(isDevMode) {
      console.log("isDevMode:", isDevMode);
      this.nonDataSlug = isDevMode ? "dev-api/api" : "api";
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword
    },
    async login() {
      try {        
        const response = await apiRequest('post', `${this.nonDataSlug}/login`, {
          email: this.email,
          password: this.password,
        });

        if (response.errorCode === 0) {
          await setUserInfo({
            firstName: response.data.first_name,
            email: response.data.email,
            token: response.data.token,
            id: response.data.id,
            accessLevel: response.data.access_level,
          });
          this.$router.push('/home');
        } else {
          if (!this.showModal) {
            this.infoTitle = "Error";
            this.infoMessage = response.infoText;
            this.showModal = true;
          }
        }
      } catch (error) {
        if (!this.showModal) {
          this.infoTitle = "Error";
          this.infoMessage = 'Unexpected backend response. Please try again later';
          this.showModal = true;
        }
      }
    },
    async registerUser() {
      try {        
        const response = await apiRequest('post', `${this.nonDataSlug}/register`, {
          email: this.email,
          password: this.password,
          first_name: this.first_name,
          last_name: this.last_name,
        });
  
        if(response.errorCode === 0) {
          if(!this.showModal){
          this.infoTitle = "Success";
          this.infoMessage = "User account created successfully. Please log in to continue";
          this.showModal = true;
          this.showRegister = false;
          this.showLogin = true;
          this.first_name = '';
          this.last_name = '';
          }
        }
        else {
          if(!this.showModal){
          this.infoTitle = "Error";
          this.infoMessage = response.infoText;
          this.showModal = true;
          }
        }
      } catch (error) {
        if(!this.showModal){
        this.infoTitle = "Error";
        this.infoMessage = 'Unexpected backend response. Please try again later';
        this.showModal = true;
        }
      }
    },
    handleHover() {
      this.$refs.forget.style.cursor = 'pointer';
    },
    showInfo(title, message){
       if(!this.showModal){
        this.infoTitle = title;
        this.infoMessage = message;
        this.showModal = true;
        }
    },
    async sendEmail() {
      try {
        this.isLoading = true;
        const response = await apiRequest('post', `${this.nonDataSlug}/recovery_code/get`, {
          email: this.email,
        });
        this.isLoading = false;
        if(response.errorCode === 0) {
          this.showModal = false;
          this.showRegister = false;
          this.showLogin = false;
          this.showResetSendingEmail = false;
          this.showResetRecoveryCode = true;
        }
        else {
          if(!this.showModal){
          this.infoTitle = "Error";
          this.infoMessage = response.infoText;
          this.showModal = true;
          }
        }
      } catch (error) {
          console.error('Failed to send reset email:', error);
          if(!this.showModal){
            this.infoTitle = "Error";
            this.infoMessage = 'Unexpected backend response. Please try again later';
            this.showModal = true;
          }
      }
    },
    async recoverAccount() {
      try {
        const response = await apiRequest('post', `${this.nonDataSlug}/new_password/set`, {
          email: this.email,
          reset_code: this.recoveryCode,
          new_password: this.newPassword,
        });
        if(response.errorCode === 0) {
          if(!this.showModal){
          this.infoTitle = "Success";
          this.infoMessage = "Your account password has been reset successfully. Please log in to continue";
          this.showModal = true;
          this.showRegister = false;
          this.showLogin = true;
          this.showResetSendingEmail = false;
          this.showResetRecoveryCode = false;
          }
        }
        else {
          if(!this.showModal){
          this.infoTitle = "Error";
          this.infoMessage = response.infoText;
          this.showModal = true;
          }
        }
      } catch (error) {
          console.error('Unexpected error with the request:', error);
          if(!this.showModal){
            this.infoTitle = "Error";
            this.infoMessage = 'Unexpected backend response. Please try again later';
            this.showModal = true;
          }
      }
    },
  },
  created() {
    const devModeState = getDevModeState();
    if (devModeState.isDevMode !== undefined) {
      this.nonDataSlug = devModeState.isDevMode ? "dev-api/api" : "api";
    }
    eventBus.on('environment-changed', this.handleEnvironmentChange);
  },
  beforeUnmount() {
    eventBus.off('environment-changed', this.handleEnvironmentChange);
  },
};
</script>



<style scoped lang="scss">

* {
  font-family: 'Work Sans', Muli, Helvetica, Arial, sans-serif;
}

  #logo {
    float: left;
    width: 15%;
    margin: 0;
    padding: 0;
  }



  .card-title {
    text-align: center;
    font-weight: 400;
    margin-top: 5%;
  }

  .custom-side-margins {
    margin-left: 10%;
    margin-right: 10%;
  }


  .underline-style {
    width: 92%;
    border-bottom: 1px solid #000;
    border-top: none;
    border-left: none;
    border-right: none;
    margin: 5%;
}


.btn-wd {
  width: 55%;
  border-radius: 8;
  background-color: #000;
  margin: 10%;
}


.custom-wd {
  width: 100%;
}


.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.forgot {
  margin-bottom: 10%;
}


.forgot > a {
  margin-bottom: 10%;
  color: #000;
}

.dark-mode .login_card .forgot > a {
  color: #ffffff;
}

.footer-semi-transparent {
    position: absolute;
    background-color: #000;
    color: #fff;
    bottom: 6%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
}

.footer-semi-transparent > p {
  font-size: 1em;
}

.footer-semi-transparent > a > p {
  font-size: 1em;
}

.footer-semi-transparent > a {
  color: white;
  text-decoration: underline;
}

.footer-child-container1 {
  margin-top: 0.35%;
}

.footer-child-container2 {
  margin-top: 0.35%;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  align-self: center;
  margin-left: 10%;
}

.footer-child-container1 > p, .footer-child-container2 > a > p  {
  color: white;
  font-size: 0.9em;
}


.full-page-background {
    position: relative;
    z-index: 1;
}

.page-wrap {
  position: relative;
  opacity: 1;
}


.page-content {
  opacity: 0.8;
  background-color: none;
  height: 100vh;
}

.page-bg {
  opacity: 1;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.input-text {
  font-size: 0.8em;
}


@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.fade-in-div {
  animation-name: fadeIn;
  animation-duration: 2s;
  animation-fill-mode: forwards;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.login_card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 6px;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, .15);
  background-color: var(--card-bg, #fff);
  color: var(--text-primary, #252422);
  margin-top: 5%;
  width: 30%;
}

.dark-mode .login_card {
  background-color: #1a1a1a;
}

.top-container {
  position: absolute;
  top: 8%;
  margin-left: 14%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  align-self: center;
  z-index: 200;
}

.top-title {
  color: white;
  size: larger;
  font-size: clamp(14px, 2vw, 20px); 
  font-weight: bold;
  margin-top: 1.8%;
}

.divider {
  height: 2em;
}

.wrapper {
    background-color: none  !important;
  }

@media (max-width: 992px){
  .wrapper {
    background-color: none  !important;
  }
}

.container, .footer-semi-transparent, button {
  font-size: 0.8rem !important;
}

button {
  color: white;
  border-radius: 4px;
}

.btn-custom-back {
  background-color: #ea8c07;
  color: white;
  border: none;
  border-radius: 8px;
}

.form-group {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  text-align: start;
}

.card-footer{
  margin-bottom: 20px;
}

.password-input-wrapper {
  position: relative;
}

.password-input-wrapper input {
  width: 100%;
  padding-right: 60px;
}

.input-text {
  width: 100%;
  padding-right: 60px;
}

.password-toggle-btn {
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  color: black;
  border: none;
  cursor: pointer;
  padding: 5px;
  font-size: 0.8em;
}

.custom-divider {
  display: block;
  height: 1.2rem;
}

label {
  font-size: 0.8rem;
  margin-left: 10%;
  margin-right: 10%;
  color: #000;
}

.dark-mode .login_card label {
  color: #ffffff;
}

.login-button{
  background-color: #000;
  margin: 10%;
}

.info-disclaimer {
  margin: 0 5% 0 5%;
  padding: 1%;
}

.info-disclaimer > p {
  font-size: 0.6em;
  color: #000;
}

@media (max-width: 950px) {

  .footer-child-container1 > p, .footer-child-container2 > a > p  {
    color: white;
    font-size: 0.4em;
  }

  .container, .footer-semi-transparent, button {
    font-size: 0.3rem !important;
  }

  .login_card {
    margin-top: 30%;
    width: 60%;
  }

  .password-input-wrapper input {
    width: 80%;
    padding-right: 60px;
  }

  .input-text {
    width: 80%;
    padding-right: 60px;
  }

  button {
    font-size: 10px;
  }

  .underline-style {
    font-size: 10px;
  }

  .btn-wd {
    width: 35%;
  }

  label {
    font-size: 10px;
  }

  .info-disclaimer > p {
    font-size: 0.4rem;
  }
}

</style>